



































import { OperationMode, operationModes } from '@spa/components/organisms/cart/model/item/operation-mode'
import OrderListItem from '@spa/components/pages/order/order/order-list/editable/OrderListItem.vue'
import { Order } from '@spa/services/order'
import { CartItem } from '@spa/store/modules/cart/types'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    OrderListItem,
  },
})
export default class OrderConfirmList extends Vue {
  @Prop({ required: true })
  orders: Order[]

  @Prop({ required: true })
  canScheduleDelivery: boolean

  @Prop({ default: () => operationModes.readOnly })
  operationMode: OperationMode

  genUniqueKey(order: Order): string {
    return order.cartItems.map(i => i.id).join('_')
  }

  @Emit()
  changeCount(_item: CartItem): void {
    // nothing to do
  }
  @Emit()
  remove(_item: CartItem): void {
    // nothing to do
  }
}
